import EditProject from 'page/Application/ManageProjectRegistration/EditProject';
import ProjectList from 'page/Application/ManageProjectRegistration/ProjectList';
import RegisterProject from 'page/Application/ManageProjectRegistration/RegisterProject';

import { Outlet } from 'react-router-dom';

const ManageProjectRegistration = () => {
  return <Outlet />;
};

export default ManageProjectRegistration;

export { EditProject, ProjectList, RegisterProject };

